import React from "react";

import { Typography } from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

import {
  Phone,
  Email,
  LocationOn,
  HeadsetMic,
  ContactMail,
} from "@material-ui/icons";
import brandTheme from "brandTheme/Theme";

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: "100vh",
    padding: "32px 48px",
    background: "linear-gradient(180deg,#FFFFFF 0%,#F5F8FF 100%)",

    [theme.breakpoints.down("md")]: {
      padding: "24px",
    },

    [theme.breakpoints.down("sm")]: {
      padding: "16px",
    },
  },

  heroSection: {
    background:
      "linear-gradient(135deg, #1CB167 0%, #1CB167 50%, #020b5c 100%)",
    borderRadius: "28px",
    padding: "70px 60px",
    color: "#fff",
    marginBottom: "40px",
    display: "flex",
    alignItems: "center",
    gap: "50px",

    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      textAlign: "center",
      padding: "48px 28px",
      gap: "28px",
    },

    [theme.breakpoints.down("sm")]: {
      padding: "32px 20px",
      borderRadius: "18px",
      marginBottom: "20px",
      gap: "20px",
    },
  },

  heroIcon: {
    width: "140px",
    height: "140px",
    minWidth: "140px",
    borderRadius: "50%",
    border: `4px solid ${brandTheme.white}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(255,255,255,0.05)",

    "& svg": {
      fontSize: "70px",
      color: "#fff",
    },

    [theme.breakpoints.down("sm")]: {
      width: "100px",
      height: "100px",
      minWidth: "100px",

      "& svg": {
        fontSize: "50px",
      },
    },
  },

  heroContent: {
    borderLeft: "2px solid rgba(255,255,255,0.25)",
    paddingLeft: "50px",

    [theme.breakpoints.down("md")]: {
      borderLeft: "none",
      paddingLeft: 0,
    },
  },

  heroTitle: {
    fontWeight: 800,
    marginBottom: "20px",
    fontSize: "56px",
    lineHeight: 1.2,

    [theme.breakpoints.down("md")]: {
      fontSize: "40px",
    },

    [theme.breakpoints.down("sm")]: {
      fontSize: "30px",
      marginBottom: "14px",
    },
  },

  heroSubtitle: {
    maxWidth: "700px",
    lineHeight: 1.8,
    fontSize: "20px",
    fontWeight: 400,

    [theme.breakpoints.down("sm")]: {
      fontSize: "15px",
      lineHeight: 1.7,
    },
  },

  contactWrapper: {
    background: "#fff",
    borderRadius: "28px",
    padding: "45px",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "40px",
    boxShadow: "0 10px 40px rgba(0,0,0,.06)",

    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "1fr",
      padding: "30px",
      gap: "30px",
    },

    [theme.breakpoints.down("sm")]: {
      padding: "18px",
      borderRadius: "18px",
      gap: "20px",
    },
  },

  leftCard: {
    paddingRight: "30px",
    borderRight: "1px solid #eee",

    [theme.breakpoints.down("md")]: {
      borderRight: "none",
      paddingRight: 0,
    },
  },

  contactHeading: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    marginBottom: "32px",

    [theme.breakpoints.down("sm")]: {
      gap: "12px",
      marginBottom: "22px",
      justifyContent: "center",
      textAlign: "center",
    },
  },
  contactTitle: {
    fontWeight: 800,
    color: brandTheme.mainColor,
    fontSize: "34px",

    [theme.breakpoints.down("md")]: {
      fontSize: "28px",
    },

    [theme.breakpoints.down("sm")]: {
      fontSize: "22px",
    },
  },

  headingIcon: {
    width: "60px",
    height: "60px",
    borderRadius: "18px",
    background: "linear-gradient(135deg,#010A4F 0%, #031D7A 45%, #5B21B6 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    "& svg": {
      color: "#fff",
      fontSize: "32px",
    },

    [theme.breakpoints.down("sm")]: {
      width: "52px",
      height: "52px",
      borderRadius: "14px",

      "& svg": {
        fontSize: "26px",
      },
    },
  },

  contactItem: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    padding: "20px 0",
    borderBottom: "1px solid #eee",

    [theme.breakpoints.down("sm")]: {
      gap: "14px",
      padding: "16px 0",
      alignItems: "center",
    },
  },

  contactCircle: {
    width: 60,
    height: 60,
    minWidth: 60,
    borderRadius: "50%",
    background: "#F1F4FA",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    "& svg": {
      color: brandTheme.mainColor,
      fontSize: 28,
    },

    [theme.breakpoints.down("sm")]: {
      width: 48,
      height: 48,
      minWidth: 48,

      "& svg": {
        fontSize: 22,
      },
    },
  },

  contactLabel: {
    color: brandTheme.mainColor,
    fontWeight: 700,
    fontSize: "13px",
    letterSpacing: "1px",

    [theme.breakpoints.down("sm")]: {
      fontSize: "11px",
    },
  },

  contactValue: {
    fontSize: "18px",
    fontWeight: 700,
    color: "#111",
    lineHeight: 1.6,
    wordBreak: "break-word",
    overflowWrap: "anywhere",

    [theme.breakpoints.down("sm")]: {
      fontSize: "15px",
      lineHeight: 1.5,
    },
  },

  grievanceSection: {
    marginTop: "35px",
    paddingTop: "30px",
    borderTop: "1px solid #eee",

    [theme.breakpoints.down("sm")]: {
      marginTop: "25px",
      paddingTop: "22px",
    },
  },

  grievanceHeading: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    marginBottom: "20px",

    [theme.breakpoints.down("sm")]: {
      gap: "10px",
      marginBottom: "16px",
    },
  },

  grievanceIcon: {
    width: "50px",
    height: "50px",
    minWidth: "50px",
    borderRadius: "14px",
    background:
      "linear-gradient(135deg,#010A4F 0%, #031D7A 45%, #5B21B6 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    "& svg": {
      color: "#fff",
      fontSize: "26px",
    },

    [theme.breakpoints.down("sm")]: {
      width: "44px",
      height: "44px",
      minWidth: "44px",
      borderRadius: "12px",

      "& svg": {
        fontSize: "22px",
      },
    },
  },

  grievanceTitle: {
    fontWeight: 800,
    color: brandTheme.mainColor,
    fontSize: "24px",

    [theme.breakpoints.down("sm")]: {
      fontSize: "19px",
    },
  },

  grievanceContent: {
    padding: "20px",
    background: "#F7F9FF",
    borderRadius: "16px",
    border: "1px solid #E7EBF5",

    [theme.breakpoints.down("sm")]: {
      padding: "16px",
      borderRadius: "12px",
    },
  },

  grievanceRow: {
    marginBottom: "14px",

    "&:last-child": {
      marginBottom: 0,
    },
  },

  grievanceLabel: {
    fontSize: "12px",
    fontWeight: 700,
    letterSpacing: "0.8px",
    color: brandTheme.mainColor,
    marginBottom: "4px",
  },

  grievanceValue: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#111",
    lineHeight: 1.5,
    wordBreak: "break-word",
    overflowWrap: "anywhere",

    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },

  mapBox: {
    borderRadius: "22px",
    overflow: "hidden",
    minHeight: "420px",
    boxShadow: "0 10px 25px rgba(0,0,0,.08)",

    [theme.breakpoints.down("md")]: {
      minHeight: "320px",
    },

    [theme.breakpoints.down("sm")]: {
      minHeight: "240px",
      borderRadius: "16px",
    },
  },

  mapIframe: {
    width: "100%",
    height: "100%",
    minHeight: "inherit",
    border: "none",
  },
}));

export default function Contact() {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {/* Hero */}
      <div className={classes.heroSection}>
        <div className={classes.heroIcon}>
          <HeadsetMic />
        </div>

        <div className={classes.heroContent}>
          <Typography variant="h3" className={classes.heroTitle}>
            Contact Us
          </Typography>

          <Typography variant="body1" className={classes.heroSubtitle}>
            {
              "We'd love to hear from you. Reach out to our team for support, loan assistance or business enquiries."
            }
          </Typography>
        </div>
      </div>

      {/* Contact Card */}
      <div className={classes.contactWrapper}>
        {/* Left Side */}
        <div className={classes.leftCard}>
          <div className={classes.contactHeading}>
            <div className={classes.headingIcon}>
              <ContactMail />
            </div>

            <Typography className={classes.contactTitle}>
              Contact Information
            </Typography>
          </div>

          {/* Phone */}
          <div className={classes.contactItem}>
            <div className={classes.contactCircle}>
              <Phone />
            </div>

            <div>
              <div className={classes.contactLabel}>PHONE</div>

              <div className={classes.contactValue}>
                +91 93191 31132
              </div>
            </div>
          </div>

          {/* Email */}
          <div className={classes.contactItem}>
            <div className={classes.contactCircle}>
              <Email />
            </div>

            <div>
              <div className={classes.contactLabel}>EMAIL</div>

              <div className={classes.contactValue}>
                Customercare@aryamanfinance.co.in
              </div>
            </div>
          </div>

          {/* Location */}
          <div
            className={classes.contactItem}
            style={{
              borderBottom: "none",
            }}
          >
            <div className={classes.contactCircle}>
              <LocationOn />
            </div>

            <div>
              <div className={classes.contactLabel}>LOCATION</div>

              <div className={classes.contactValue}>
                105, First Floor, Barodia Tower, D-Block, Central Market,
                Prashant Vihar, Rohini, Delhi-110085, India
              </div>
            </div>
          </div>

          <div className={classes.grievanceSection}>
            <div className={classes.grievanceHeading}>
              <div className={classes.grievanceIcon}>
                <ContactMail />
              </div>

              <Typography className={classes.grievanceTitle}>
                Grievance Officer
              </Typography>
            </div>

            <div className={classes.grievanceContent}>
              <div className={classes.grievanceRow}>
                <div className={classes.grievanceLabel}>DIVISION</div>

                <div className={classes.grievanceValue}>
                  Delhi Division-Digital Lending-Ms Varsha
                </div>
              </div>

              <div className={classes.grievanceRow}>
                <div className={classes.grievanceLabel}>COMPANY</div>

                <div className={classes.grievanceValue}>
                  Aryaman Finance (India) Limited
                </div>
              </div>

              <div className={classes.grievanceRow}>
                <div className={classes.grievanceLabel}>ADDRESS</div>

                <div className={classes.grievanceValue}>
                  First Floor, DDA Office No. 105, Barodia Tower, Prashant
                  Vihar, Rohini, New Delhi, 110085
                </div>
              </div>

              <div className={classes.grievanceRow}>
                <div className={classes.grievanceLabel}>EMAIL</div>

                <div className={classes.grievanceValue}>
                  ig@aryamanfinance.co.in
                </div>
              </div>

              <div className={classes.grievanceRow}>
                <div className={classes.grievanceLabel}>PHONE</div>

                <div className={classes.grievanceValue}>
                  +91-8375864063
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side */}
        <div className={classes.mapBox}>
          <iframe
            className={classes.mapIframe}
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3499.229487865046!2d77.13491507504273!3d28.71268697562111!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d017caeeec6c7%3A0xf57a2a3dfa7eb852!2sBarodia%20Tower%2C%20D-Block%2C%20Central%20Market%2C%20Pvr%20Prashant%20Vihar%20Road%2C%20Prashant%20Vihar%2C%20Sector%2014%2C%20Rohini%2C%20Delhi%2C%20110085!5e0!3m2!1sen!2sin!4v1782710746479!5m2!1sen!2sin"
            allowFullScreen=""
            loading="lazy"
            title="Location"
          />
        </div>
      </div>
    </div>
  );
}
